/* import __COLOCATED_TEMPLATE__ from './header.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */
import templateOnlyComponent from '@ember/component/template-only';

interface Args {
  isLoading: boolean;
  hasUnsavedChanges: boolean;
  onCancel: () => void;
  onApplyChanges: () => void;
}

interface Signature {
  Args: Args;
  Element: HTMLDivElement;
  Blocks: {};
}

const ScimHeader = templateOnlyComponent<Signature>();
export default ScimHeader;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Workspace::Teammates::Scim::Header': typeof ScimHeader;
    'new-settings/workspace/teammates/scim/header': typeof ScimHeader;
  }
}
